import { render, staticRenderFns } from "./AdditionProduct.vue?vue&type=template&id=95fafadc&scoped=true"
import script from "./AdditionProduct.vue?vue&type=script&lang=js"
export * from "./AdditionProduct.vue?vue&type=script&lang=js"
import style0 from "./AdditionProduct.vue?vue&type=style&index=0&id=95fafadc&prod&lang=scss"
import style1 from "./AdditionProduct.vue?vue&type=style&index=1&id=95fafadc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fafadc",
  null
  
)

export default component.exports